import { render, staticRenderFns } from "./notification-settings.vue?vue&type=template&id=323d0267&scoped=true&"
import script from "./notification-settings.vue?vue&type=script&lang=js&"
export * from "./notification-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d0267",
  null
  
)

export default component.exports